module.exports = __webpack_public_path__ + "img/jane-umren-profile-picture.83deb921.png";